import { differenceInCalendarDays, endOfDay, startOfDay, OwaDate } from 'owa-datetime';

/**
 * Gets the duration in days between the start and the end
 *  @param start the start date of the event
 *  @param end the end date of the event
 *  @returns the duration between start and end
 */
export default function getDurationInDays(start: OwaDate, end: OwaDate): number {
    return differenceInCalendarDays(endOfDay(end), startOfDay(start));
}
